import React from 'react';
import '../styles/OurValues.css';

const OurValues: React.FC = () => {
  const values = [
    {
      title: "Integrity First",
      description: "We build trustworthy AI with transparency, responsibility, and a deep respect for privacy and security."
    },
    {
      title: "Real-World Impact",
      description: "Innovation is only valuable when it solves real problems. We focus on creating technology that delivers measurable value."
    },
    {
      title: "Collaboration Over Ego",
      description: "We believe the best results come from listening, learning, and working together — across disciplines, industries, and cultures."
    },
    {
      title: "Excellence Through Iteration",
      description: "Progress is a process. We aim for excellence through constant improvement and a commitment to quality."
    },
    {
      title: "User-Centered Innovation",
      description: "Whether it's a developer or an operations manager, we design solutions with the end user in mind."
    }
  ];

  return (
    <section className="our-values">
      <div className="container">
        <h2 className="section-title">Our Values</h2>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurValues;
